import { IOrder } from './models/details';
import { OrderStateModel } from './models/order';

export const getOrderDetails = (state: OrderStateModel): IOrder => state.order;
